import React from "react";
import OverviewSimplePanel from "./OverviewSimplePanel";
import OverviewComplexPanel from "./OverviewComplexPanel";
import OverviewPanelProps from "./OverviewPanelProps";
import { useContext } from "react";
import PersonalizationContext from "../../PersonalizationComponents/PersonalizationContext";

function OverviewPanel(props: OverviewPanelProps) {
  const { personalizationConfig, setPersonalizationConfig } = useContext(PersonalizationContext);

  if ("complexity" in personalizationConfig && personalizationConfig.complexity === "simple") {
    return <OverviewSimplePanel {...props} />;
  } else {
    return <OverviewComplexPanel {...props} />;
  }
}

export default OverviewPanel;
